'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_JoinGeneralPracticeResponse$$anon$9() {
}
export { $c_Lapp_api_JoinGeneralPracticeResponse$$anon$9 as $c_Lapp_api_JoinGeneralPracticeResponse$$anon$9 };
$c_Lapp_api_JoinGeneralPracticeResponse$$anon$9.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_JoinGeneralPracticeResponse$$anon$9.prototype.constructor = $c_Lapp_api_JoinGeneralPracticeResponse$$anon$9;
/** @constructor */
function $h_Lapp_api_JoinGeneralPracticeResponse$$anon$9() {
}
export { $h_Lapp_api_JoinGeneralPracticeResponse$$anon$9 as $h_Lapp_api_JoinGeneralPracticeResponse$$anon$9 };
$h_Lapp_api_JoinGeneralPracticeResponse$$anon$9.prototype = $c_Lapp_api_JoinGeneralPracticeResponse$$anon$9.prototype;
$c_Lapp_api_JoinGeneralPracticeResponse$$anon$9.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_JoinGeneralPracticeResponse$$anon$9.prototype.apply__O = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForBoolean;
});
var $d_Lapp_api_JoinGeneralPracticeResponse$$anon$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_JoinGeneralPracticeResponse$$anon$9, "app.api.JoinGeneralPracticeResponse$$anon$9", ({
  Lapp_api_JoinGeneralPracticeResponse$$anon$9: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_JoinGeneralPracticeResponse$$anon$9 as $d_Lapp_api_JoinGeneralPracticeResponse$$anon$9 };
//# sourceMappingURL=app.api.-Join-General-Practice-Response$$anon$9.js.map
